import { getCancerDisabled, getCriticalIllnessDisabled } from './Disclaimers';

function getCancerBrochure(state) {
    if (getCancerDisabled(state)) return null;
    var pdfs = {
        'NH': 'A76175NH',
        'NJ': 'A76175ESLNJ',
        'OH': 'A76175ESL',
        'PA': 'A76175LPA',
        'PR': 'A75175LPR',
        'WA': 'A76175ESLWA'
    }
    var brochure = pdfs[state];

    if (brochure) {
        return {
            download: true,
            filename: brochure
        }
    } else {

        var plan = "cancer_base";
        if (state === 'CT' || state === 'OR') {
            plan = "cancer_base_no_sdb_rider";
        }
        return {
            url: `https://www.aflac.com/products/cancer.aspx?state=${state}&plan=${plan}&add_ons=initial_rider+specified_rider+child_rider+`
        }
    }
}

function getAccidentBrochure(state) {
    var pdfs = {
        'CA': 'A35B2475RVRCA',
        'CO': 'A35B2475CO',
        'ID': 'A35B2475RVID',
        'IN': 'A35B2475NrvRIN',
        'MD': 'A35B2475NrvRMD',
        'OH': 'A35B2475NRVOH',
        'OR': 'A35B2475RVOR',
        'PR': 'A34575LPR',
        'RI': 'A35B2475RVRRI',
        'TX': 'A35B2475RVRTX',
        'VA': 'A35B2475NrvVA',
        'VT': 'A35B2475rvRVT',
        'WA': 'A35B2475RVWA'
    }
    var brochure = pdfs[state];

    if (brochure) {
        return {
            download: true,
            filename: brochure
        }
    } else {
        return {
            url: `https://www.aflac.com/direct-products/accident.aspx?state=${state}&plan=accident_base&add_ons=aad_rider+`
        }
    }
}

function getCriticalIllnessBrochure(state) {
    if (getCriticalIllnessDisabled(state)) return null;
    var pdfs = {
        'CO': 'A71175NRVCO',
        'KY': 'A71175NrvKY',
        'MD': 'A71175NrvMD',
        'ME': 'A71175rvME',
        'OH': 'A71175NRVOH',
        'PR': 'A71175L2PR',
        'RI': 'A71175rvRI',
        'TN': 'A71175L3TN',
        'VA': 'A71175L3VA',
        'WA': 'A70175RVWA'
    }
    var brochure = pdfs[state];

    if (brochure) {
        return {
            download: true,
            filename: brochure
        }
    } else {
        return {
            url: `https://www.aflac.com/direct-products/critical-illness.aspx?state=${state}&plan=criticalillness_base&add_ons=recovery+hospital+`
        }
    }
}

export { getCancerBrochure, getAccidentBrochure, getCriticalIllnessBrochure, getCancerDisabled, getCriticalIllnessDisabled }


// WEBPACK FOOTER //
// ./src/components/Quoters/Supplemental/Helpers/Brochures.js